/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getShortlink} from '../api'

 export const useQueryGetShortlink = createReactQueryHook('getShortlink', getShortlink)
